import * as React from 'react';

const { useEffect, useRef } = React;

type IntervalFunction = () => unknown | void;

export function useIntervalWithTimeout(
  callback: IntervalFunction,
  delay: number | null,
  timerRunning: boolean,
  timeout?: number,
  timeoutCallback?: IntervalFunction,
) {
  const intervalIdRef = useRef<NodeJS.Timer | null>(null);
  const timeoutIdRef = useRef<NodeJS.Timer | null>(null);
  const savedCallback = useRef<IntervalFunction | null>(null);

  useEffect(() => {
    if (delay === null) return;
    savedCallback.current = callback;
  });

  useEffect(() => {
    if (delay === null) return;
    function tick() {
      if (savedCallback.current !== null) {
        savedCallback.current();
      }
    }
    intervalIdRef.current = setInterval(tick, delay);
    if (timeout) {
      timeoutIdRef.current = setTimeout(() => {
        clearInterval(intervalIdRef.current!);
        timeoutCallback && timeoutCallback();
      }, timeout);
    }
    return () => {
      clearInterval(intervalIdRef.current!);
      if (timeoutIdRef.current) {
        clearInterval(timeoutIdRef.current);
      }
    };
  }, [delay]);

  useEffect(() => {
    if (!timerRunning && intervalIdRef.current && timeoutIdRef.current) {
      clearInterval(intervalIdRef.current);
      clearTimeout(timeoutIdRef.current);
    }
  }, [timerRunning]);
}
